<template>
  <section>
    <div class="title" v-if="role === 'self'">我的收藏({{totalRows}})</div>
    <div class="title" v-if="role === 'other'">他的帖子({{totalRows}})</div>
    <div class="articleList">
      <div class="item" v-for="article in dataLst" :key="article.articleId">
        <div class="itemImg" v-bind:style="{backgroundImage:'url(' + (article.frontImage || 'http://video.naolamp.com/bbs_front/1529041405718.jpg') + ')',
                  backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover'}">
        </div>
        <div class="itemTitle">
          <router-link tag="a" target="_blank" :to="{name: 'articleDetail',query: {articleId:article.articleId}}">
            {{article.title}}
          </router-link>
        </div>
        <div class="itemFun">
          <div class="funLeft">
            <img :src="article.headImg || defaultHead"/>
            <div>{{article.userName}}</div>
          </div>
          <div class="itemCount">
            <span><i class="iconfont icon-comments"></i>&nbsp;{{article.replyCount | maxNumFix(99)}}</span>
            <span><i class="iconfont icon-praise"></i>&nbsp;{{article.handCount | maxNumFix(999)}}</span>
          </div>
        </div>
      </div>
      <div class="noData" v-show="!dataLst || dataLst.length ===0 && role === 'self'">暂时没有收藏~</div>
      <div class="noData" v-show="!dataLst || dataLst.length ===0 && role === 'other'">暂时没有帖子~</div>
    </div>
    <laypage :pages="totalPages" @jump="updateDataPage" v-show="dataLst && totalRows > pageSize"
             :groups="totalPages>8?8:totalPages" skip="skip" class="layPage"></laypage>
    <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
  </section>
</template>

<script>
import loading from '../common/loading.vue'
export default {
  name: 'userHome',
  props: {
    role: {
      type: String,
      default: 'self'
    },
    userId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      msg: '个人中心',
      page: 1,
      pageSize: 6,
      defaultHead: require('../../assets/image/installer.png'),
      totalPages: 10,
      totalRows: 0,
      dataLst: [{
        'summary': '加载中...',
        'createTime': 1528969629000,
        'handCount': 999,
        'replyCount': 999,
        'tab': 'D32,奥迪,',
        'good': 'N',
        'articleId': 5,
        'lastReplyTime': 1528969629000,
        'open': 'Y',
        'title': '常用车灯用语你懂多少',
        'headImg': null,
        'isRelease': 'Y',
        'userId': '402888c563f7211f0163f721b2d10000',
        'visitCount': 999,
        'userName': '用户9569',
        'articleWay': 'Y',
        'frontImage': 'http://video.naolamp.com/bbs_front/1528969629659.png',
        'top': 'N'
      }],
      isLoad: true
    }
  },
  computed: {
  },
  mounted: function (s) {
    this.getDataLst()
  },
  methods: {
    'updateDataPage': function (p) {
      this.page = p
      this.getDataLst()
    },
    'getDataLst': function () {
      this.isLoad = true
      let that = this
      let method = 'collectList'
      let userId = this.$root.getUserId()
      if (this.role === 'other') {
        method = 'list'
        userId = this.userId
      }
      that.axios.post('topic/' + method, {
        userId: userId,
        page: that.page,
        pageSize: that.pageSize
      }, {
        emulateJSON: true// 需要转json
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          var res = response.data.value
          that.dataLst = res.dataLst
          that.totalPages = res.totalPages
          that.totalRows = res.totalRows
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  filters: {},
  components: {
    loading
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  padding-left: 30px;
  background-color: #FFFFFF;
  height: 50px;
  line-height: 50px;
  margin-bottom: 10px;
}
.articleList {
  width: 980px;
}
.articleList .noData {
  width: 950px;
  margin-top: 20px;
  background-color: #FFFFFF;
  text-align: center;
  line-height: 100px;
  color: #A0A0A0;
}
.articleList .item {
  width: 323.33px;
  float: left;
  margin-bottom: 20px;
}
.item .itemImg {
  width: 305px;
  height: 216px;
}
.item .itemTitle {
  padding-right: 10px;
  padding-left: 14px;
  width: 281px;
  line-height: 50px;
  height: 50px;
  background-color: #FFFFFF;
  border-bottom: 1px solid #F0F0F0;
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
}
.item .itemFun {
  background-color: #FFFFFF;
  width: 291px;
  padding-left: 14px;
  height: 76px;
  line-height: 76px;
}
.itemFun .funLeft img {
  margin: 24px 0;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  float: left;
}
.itemFun .funLeft div {
  float: left;
  padding-left: 10px;
  cursor: pointer;
  font-size: 14px;
}
.itemFun .funLeft div:hover {
  color: #05B570;
}
.itemFun .itemCount {
  float: right;
  display: flex;
}
.itemFun .itemCount span {
  display: flex;
  align-items: center;
  padding-right: 10px;
  font-size: 12px;
  color: #6a6a6a;
}
  .icon-comments,
  .icon-praise{
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/userCollect.vue